"use strict";

define('rs/modals/table.finder/table.finder.controller',['require','exports','module','rs/modals/finder/finder.controller','rs/modals/table.finder/table.finder.view','e3-table'],function (require, exports, module) {
  var FinderController = require('rs/modals/finder/finder.controller');
  var TableFinderView = require('rs/modals/table.finder/table.finder.view');
  var E3Table = require('e3-table');
  var TableFinderController = FinderController.extend({
    columns: [],
    properties: ['columns', 'tableController', 'remoteSort', 'remoteFilter'],
    initialize: function initialize() {
      this._super.apply(this, arguments);
      this.setupTableController();
    },
    getTableOptions: function getTableOptions() {
      return {
        columns: this.getColumns(),
        delegate: this,
        multiSelect: this.getMultiSelect(),
        persistSelection: true,
        remoteFiler: this.getRemoteFilter(),
        remoteSort: this.getRemoteSort(),
        idProperty: this.idProperty,
        theme: 'rs'
      };
    },
    startListeners: function startListeners() {
      this.listenTo(this.getTableController(), 'change:selectedItems', this.refreshItemsOnView);
    },
    viewIsAvailable: function viewIsAvailable() {
      var el = this.getView().getItemsContainer();
      if (!this.getTableController()) {
        throw new Error('You must initialize a table controller in a finder modal');
      }
      this.getTableController().setup(el);
      this._super();
    },
    getItems: function getItems() {
      return _.pluck(this.getTableController().getSelectedItems(), 'item');
    },
    deleteSelectedItem: function deleteSelectedItem(id) {
      return this.getTableController().unselectItemById(id);
    },
    setAriaLabelForRow: function setAriaLabelForRow(el, index, isSelected) {
      var tableItems = this.getTableController().items;
      var columns = this.getTableController().columns;
      var element = tableItems[index];
      if (element) {
        var content = "";
        columns.forEach(function (column) {
          if (column.displayName) {
            content += column.displayName + " " + (element.item[column.name] || "blank") + "; ";
          }
        });
        el.attr({
          'aria-label': 'Row ' + (index + 1) + '; ' + content + (isSelected ? "check mark button selected" : "add button unselected")
        });
      }
    },
    tableItemWasSelected: function tableItemWasSelected(data) {
      var $el = this.getTableController().getView().getTableRowById(data.id);
      this.setAriaLabelForRow($el, $el.data('index'), true);
      $el.find('.fa-icon-plus').removeClass('fa-icon-plus').addClass('fa-icon-check').attr('aria-label', 'currently added; remove');
    },
    tableItemWasUnselected: function tableItemWasUnselected(data) {
      var $el = this.getTableController().getView().getTableRowById(data.id);
      this.setAriaLabelForRow($el, $el.data('index'), false);
      $el.find('.fa-icon-check').removeClass('fa-icon-check').addClass('fa-icon-plus').attr('aria-label', 'add');
    },
    refresh: function refresh() {
      return this.getTableController().refresh();
    },
    sectionIsReady: function sectionIsReady() {
      var view = this.getView();
      this.render();
      return this.getTableController().importSelectedItems(this.items || []).start().bind(this).then(function () {
        if (!this.getLoadAll() && this.getShowFilter()) {
          view.showFinderMsg();
        }
      });
    },
    setupTableController: function setupTableController() {
      this.setTableController(new E3Table.Controller(this.getTableOptions()));
    },
    setupView: function setupView() {
      this.setView(new TableFinderView());
    },
    getData: function getData() {
      return this.requestItems();
    },
    requestItems: function requestItems() {
      var searchQuery = this.getFilter();
      var view = this.getView();
      if (searchQuery || !this.getShowFilter() || this.getLoadAll()) {
        return this._showRequestedItems(searchQuery, view);
      } else {
        view.showFinderMsg();
        return Promise.resolve([]);
      }
    },
    _showRequestedItems: function _showRequestedItems(searchQuery, view) {
      return this._requestTableItems(searchQuery).then(function (results) {
        view.showTableContents(results);
        return results;
      });
    },
    _requestTableItems: function _requestTableItems() {
      return Promise.resolve([]);
    }
  });
  module.exports = TableFinderController;
});

